<template>
    <div v-if="section.is_active">
        <h2 class="text-28 lg:text-36 text-navy font-bold mt-10 mb-2" id="mc_leads">Multi-Carrier Leads</h2>
        <div class="text-xl mb-4">The most filters, the highest quality, more hires.</div>

        <div class="flex lg:hidden justify-center my-4">
            <img 
                src="/proposal-presentation-files/img/mc-funnel.png" 
                alt="Multi-carrier" 
                class="cursor-pointer"
                style="max-height: 327px"
                data-img-container="1"
                @click="enlargeImage"
            >
        </div>
        <div class="flex gap-x-4 bg-white shadow p-6 lg:p-8 tr-box">
            <ul class="tr-bullets ml-4 flex flex-col gap-y-2 w-full lg:gap-y-4 lg:w-1/2 lg:my-12">
                <li v-for="(bullet, index) in bullets" :key="index" v-html="bullet"></li>
            </ul>

            <div class="hidden lg:flex w-1/2 justify-center">
                <img 
                    src="/proposal-presentation-files/img/mc-funnel.png" 
                    alt="Multi-carrier" 
                    class="duration-500 hover:scale-110 cursor-pointer"
                    data-img-container="1"
                    style="max-height: 327px"
                    @click="enlargeImage"
                >
            </div>
        </div>

        <proposal-modal-image
            v-if="modalImage"
            :modal-image-url="modalImageUrl"
            :modal-image-container="modalImageContainer"
            @close="modalImage = false"
        />
    </div>
</template>

<script>
import ProposalModalImage from "./proposal-modal-image";
import sellingPointMixin from '../sellingPointMixin';

export default {
    components: {
        ProposalModalImage,
    },
    mixins: [
        sellingPointMixin
    ],
    props: [
        'section',
    ],
    computed: {
        bullets() {
            return this.formatBullets(this.section.content);
        },
    },
}
</script>